// extracted by mini-css-extract-plugin
export default {"wrapper":"NewSongsFull_wrapper__R0jJb","title":"NewSongsFull_title__CRJ2j"};